import { BackButton, Breadcrumbs, MUITipsCard } from '../../Shared'
import { BREADCRUMS, PAGES_ROUTES } from '../../../Constants'
import { useParams, useNavigate } from 'react-router-dom'
import { BreadcrumsModel } from '../../../Models'
import { BULK_STATE_CHANGE } from '../../../Constants/Texts'
import { TIPS_MODULE } from '../../../Helpers/ManageTips'
import { findKeyByWords } from '../../../Helpers/Util'
import BulkStateChangeEditorForm from './BulkStateChangeEditorForm'

const BulkStateCreateDetail = () => {
  const params = useParams()
  const navigate = useNavigate()

  const { pageType } = params
  return (
    <div className={'role__editor pb-120'}>
      <div className='pl-10'>
        <Breadcrumbs breadcrums={BREADCRUMS.BULK_STATE_CHANGE() as BreadcrumsModel[]} />
        <BackButton
          label={BULK_STATE_CHANGE.TITLE}
          className='col73'
          handleOnClick={() =>
            navigate(`/${PAGES_ROUTES.BulkOpration}/${PAGES_ROUTES.BulkStateListing}`)
          }
        />
      </div>
      <div className='mt-1'>
        <div className='role__editor-wrapper'>
          <div className='role__editor-content p-8'>
            <BulkStateChangeEditorForm />
          </div>
          <div className=' p-8  ml-1 '>
            <MUITipsCard
              module={TIPS_MODULE.BULK_STATE_CHANGE}
              pageType={pageType}
              page={findKeyByWords(`bulk_state_change ${pageType}`)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulkStateCreateDetail
